const { sm3, sm4 } = require('sm-crypto');
import defaultSettings from '@/settings';
/**
 * 指定的字符集中生成随机字符串
 * @param {number} length
 * @param {string} chars
 */
function randomString(length, chars) {
  var result = '';
  for (var i = length; i > 0; --i) {
    result += chars[Math.floor(Math.random() * chars.length)];
  }
  return result;
}
/**
 * 将对象排序
 * @param {any} json
 */
function sortJson(json) {
  if (Object.prototype.toString.call(json) === '[object Object]') {
    // 对象按key排序后返回
    const keys = Object.keys(json).sort();
    const sortedObj = {};
    for (let index = 0; index < keys.length; index++) {
      const key = keys[index];
      const value = json[key];
      const valueType = Object.prototype.toString.call(value);
      if (valueType !== '[object Null]' && valueType !== '[object Undefined]') {
        // 值是undefined和null的参数过滤掉
        sortedObj[key] = json[key];
      }
    }
    return sortedObj;
  } else {
    // 数组/字符串/数字等直接原样返回
    return json;
  }
}
/**
 * 将json转换为字符串
 * @param {object} obj
 */
function jsonToStr(obj) {
  const json = sortJson(obj);
  if (json instanceof Array) {
    // 如果是数组
    const tmpArr = [];
    for (let i = 0; i < json.length; i++) {
      tmpArr.push(jsonToStr(json[i]));
    }
    return '[' + tmpArr.join(',') + ']'; // 如果json是数组，那么最终会return这个
  } else if (Object.prototype.toString.call(json) === '[object Object]') {
    // 如果是对象
    const tmpArr = [];
    for (const n in json) {
      // '"' + n + '"
      tmpArr.push(JSON.stringify(n) + ':' + jsonToStr(json[n]));
    }
    return '{' + tmpArr.join(',') + '}'; // 如果json是对象，那么最终会return这个
  } else if (typeof json === 'string') {
    // 如果是字符串
    return '"' + json.replace(/(\\|\")/g, '\\$1').replace(/\n/g, '\\n') + '"'; // 如果json是字符串，就过滤掉斜杠、双引号、换行再返回
  } else {
    return json; // 否则就原样返回
  }
}

/**
 * 计算请求签名
 * @param {Object} config 请求配置项
 * @returns {Object} config 修改后的配置
 */
export function calculationSign(config) {
  if (!config.data) return config; // 没有参数，就不计算签名
  // 随机字符串
  // const reqSeqNo = randomString(
  //   32,
  //   '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  // )
  // 时间戳
  // const reqTime = Date.now()
  // 排序后的对象字符串
  let sortParamStr = '';
  const sign = '';
  try {
    // console.log(config.data)
    sortParamStr = jsonToStr(config.data);
  } catch (error) {
    console.error(error);
  }
  // 加密字符串
  const encryptParam = sm4.encrypt(sortParamStr, defaultSettings.sm4Key);
  // 摘要字符串
  // try {
  //   sign = sm3(encryptParam + reqSeqNo + reqTime).toUpperCase()
  // } catch (error) {
  //   console.error(error)
  // }
  // config.headers['sign'] = sign
  // config.headers['reqSeqNo'] = reqSeqNo
  // config.headers['reqTime'] = reqTime
  config.data = encryptParam;
  return config;
}

// 解密方法
export function decrypt(text) {
  return sm4.decrypt(text, defaultSettings.sm4Key);
}

/**
 * 计算请求签名
 * @param {Object} config 请求配置项
 * @returns {Object} config 修改后的配置
 */
export function calculationSignNew(data) {
  if (!data) return data; // 没有参数，就不计算签名
  // 排序后的对象字符串
  let sortParamStr = '';
  try {
    sortParamStr = jsonToStr(data);
  } catch (error) {
    console.error(error);
  }
  // 加密字符串
  const encryptParam = sm4.encrypt(sortParamStr, defaultSettings.sm4Key);
  data = encryptParam;
  return data;
}